import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetails.vue?vue&type=style&index=0&id=1e0c8e64&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0c8e64"]])

export default __exports__